module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/common/searchbar/searchbar.scss
// module id = ./web/modern/components/common/searchbar/searchbar.scss
// module chunks = 0